import {
  Box,
  Center,
  Checkbox,
  Container,
  Divider,
  Flex,
  HStack,
  Input,
  Text,
  Textarea,
  useBoolean,
  useToast,
} from "@chakra-ui/react";
import { serviceAreaAry } from "assets/data/servicearea";
import CompanyInfo from "components/CompanyInfo";
import DaumPostCodeModal from "components/DaumPostCodeModal";
import ScheduleRecordModal from "components/ScheduleRecordModal";
import { digit } from "lib/utils/digit";
import { onRegexValidationPhone } from "lib/utils/regular";
import queryString from "query-string";
import { ChangeEvent, useEffect, useState } from "react";
import { Address } from "react-daum-postcode";
import { useLocation } from "react-router-dom";
import SubTitle from "./components/SubTitle";
import OrderItem from "./components/OrderItem";
import SelectBtn from "./components/SelectBtn";
import ReservationInfo from "routes/Order/components/ReservationInfo";
import ShippingInput from "./components/ShippingInput";
import { callOrderMerchantUidApi, getShippingAddress } from "./api";
import { useMutation, useQuery } from "@tanstack/react-query";
import { BasketListStatus, ResStatus } from "lib/api/enum";
import { getItemList } from "routes/Products/api";
import { ItemModel } from "lib/api/model";
import withAuth from "lib/hook/withAuth";
import { getPGType } from "lib/api";
import usePathNavigate from "lib/hook/usePathNavigate";
import { callDeliveryFee } from "lib/api/index";
import { DeliveryFeeData } from "lib/api/type";

import ExternalLinkModal from "components/ExternalLinkModal";
import { useRecoilState } from "recoil";

interface AddressParams {
  zonecode: string;
  roadAddress: string;
  detailAddress: string;
  sido: string;
  sigungu: string;
  sigunguCode: string;
}

export interface scheduleParams {
  isFace: boolean;
  date: string;
}

const OrderSheet = () => {
  const location = useLocation();
  const query = queryString.parse(location.search);
  // http://localhost:3000/order/ordersheet?items=333,334
  const toast = useToast();

  const { pathNavigate, backNavigate } = usePathNavigate();
  console.log("path : ", window.location.origin);

  const [isOpen, setIsOpen] = useState(false);
  const [url, setUrl] = useState("");

  const onClose = () => {
    setIsOpen(false);
    setUrl("");
  };

  // 이름
  const [name, setName] = useState<string>("");
  const onChangeName = (e: ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
  };

  // 전화번호
  const [phone, setPhone] = useState<string>("");
  const onChangePhone = (e: ChangeEvent<HTMLInputElement>) => {
    const phoneNum = onRegexValidationPhone(e.target.value);
    setPhone(phoneNum);
  };

  // 주소
  const [addressData, setAddressData] = useState<AddressParams>({
    zonecode: "",
    roadAddress: "",
    sido: "",
    sigungu: "",
    sigunguCode: "",
    detailAddress: "",
  });

  // 배송
  const [activePost, setActivePost] = useBoolean(false);
  // const [isArea, setIsArea] = useState<boolean>();
  // const [parcel, setParcel] = useState<boolean>(false);
  // const [butler, setButler] = useState<boolean>(false);
  const [shipping, setShipping] = useState<boolean>(true);
  const [comments, setComments] = useState("");
  const [deliveryMethod, setDeliveryMethod] = useState<number>(1);

  const [scheduleData, setScheduleData] = useState<scheduleParams>();

  const [card, setCard] = useState<boolean>();
  const changePaymentMethod = (isCard: boolean) => {
    setCard(isCard);
  };

  const [servicePrice, setServicePrice] = useState<number>(100000);
  const [deliveryPrice, setDeliveryPrice] = useState<number>(0);
  const [discount] = useState<number>(0);
  const [totalPrice, setTotalPrice] = useState<number>(100000);

  const [deliveryFee, setDeliveryPee] = useState<DeliveryFeeData[]>([
    {
      delivery_method: 0,
      fee_amount: 10000,
    },
    {
      delivery_method: 1,
      fee_amount: 0,
    },
    {
      delivery_method: 2,
      fee_amount: 0,
    },
    {
      delivery_method: 3,
      fee_amount: 2500,
    },
  ]);

  useQuery(["getDeliveryFee"], () => callDeliveryFee(), {
    enabled: true,
    onSuccess: (data) => {
      console.log("getDeliveryFee : ", data);

      if (data.status === ResStatus.RES_SUCCESS) {
        setDeliveryPee(data.command.delivery_method);
      }
    },
  });

  const getDeliveryFee = (method: number) => {
    // 이벤트 채널 bybtheh 일 때 배송비 0원
    // const channel = localStorage.getItem("channel");
    // if (channel === "bybtheh") {
    //     return 0;
    // } else {
    // }
    return deliveryFee.find((fee) => fee.delivery_method === method)
      ?.fee_amount;
  };

  const checkArea = (sigunguCode: string) => {
    const areaAry: string[] = serviceAreaAry() as string[];
    const area = areaAry.some((code) => code === sigunguCode);
    // setIsArea(area);
    // setParcel(true);
    setShipping(true);
    const channel = localStorage.getItem("channel");
    setDeliveryMethod(channel === "smcare" || channel === "cosmocare" ? 1 : 3);
    if (area) {
      // setButler(true);
    } else {
      // setButler(false);
      setScheduleData(undefined);
    }
  };

  useQuery(["getShippingAddress"], () => getShippingAddress({ count: 1 }), {
    enabled: true,
    onSuccess: (data) => {
      console.log("getShippingAddress : ", data);

      if (data.status === ResStatus.RES_SUCCESS) {
        if (data.command.user_address.length > 0) {
          const adData = data.command.user_address[0];

          setName(adData.address_name);
          setPhone(adData.address_phone);
          setAddressData({
            zonecode: adData.post_num,
            roadAddress: adData.address,
            sido: adData.sido,
            sigungu: adData.sigungu,
            sigunguCode: adData.sigungu_code,
            detailAddress: adData.address_detail,
          });
          checkArea(adData.sigungu_code);
        }
      } else {
      }
    },
    onError: (err: any) => {
      toast({
        title: "오류",
        description: err.message,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    },
  });

  const callbackPostCode = (data?: Address) => {
    setActivePost.off();
    if (data === null || data === undefined) return;

    setAddressData({
      zonecode: data.zonecode,
      roadAddress: data.roadAddress,
      sido: data.sido,
      sigungu: data.sigungu,
      sigunguCode: data.sigunguCode,
      detailAddress: "",
    });
    checkArea(data.sigunguCode);
  };

  const onChangeDetailAddress = (e: ChangeEvent<HTMLInputElement>) => {
    setAddressData((prevState) => ({
      ...prevState,
      detailAddress: e.target.value,
    }));
  };

  // const changeShipping = (isParcel: boolean) => {
  //     if (isParcel) {
  //         if (!parcel) return;
  //         setShipping(true);
  //         setDeliveryPrice(getDeliveryFee(3) ?? 2500);
  //     } else {
  //         if (!butler) return;
  //         setShipping(false);
  //         setDeliveryPrice(getDeliveryFee(0) ?? 10000);
  //     }
  // };

  const [activeSchedule, setActiveSchedule] = useBoolean(false);
  const callbackSchedule = (data?: scheduleParams) => {
    setActiveSchedule.off();
    if (data === null || data === undefined) return;

    setScheduleData({
      isFace: data.isFace,
      date: data.date,
    });
  };
  const onChangeComments = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setComments(e.target.value);
  };

  // 주문 아이템
  const [orderData, setOrderData] = useState<ItemModel[]>([]);

  const { mutate: itemListMutate } = useMutation(getItemList, {
    onSuccess: (data, variables) => {
      console.log("getItemList : ", variables, data);
      if (data.status === ResStatus.RES_SUCCESS) {
        setOrderData(data.command.item_list);
      } else {
        backNavigate();
        toast({
          title: "오류",
          description: `${data.status} : ` + data.result_message,
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top",
        });
      }
    },
    onError: (error: any) => {
      console.log("error : ", error);
      toast({
        title: "오류",
        description: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top",
      });
    },
  });

  // 결제방식
  useEffect(() => {
    console.log("orderData : ", orderData);

    const channel = localStorage.getItem("channel");
    // setDeliveryMethod(channel === "smcare" ? 1 : 3);

    setDeliveryPrice(
      getDeliveryFee(channel === "smcare" || channel === "cosmocare" ? 1 : 3) ??
        2500
    );

    const price = orderData.reduce((acc, cur) => acc + cur.item_price, 0);
    setServicePrice(price);
    setTotalPrice(price + deliveryPrice + discount);
  }, [orderData, deliveryPrice, discount]);

  const [checkedItems, setCheckedItems] = useState([false, false, false]);
  const allChecked = checkedItems.every(Boolean);

  const [isActiveBtn, setIsActiveBtn] = useBoolean(false);
  const checkActiveBtn = () => {
    setIsActiveBtn.off();
    console.log(
      "checkActiveBtn : ",
      name,
      phone,
      addressData,
      card,
      allChecked
    );

    if (
      name &&
      name.length >= 2 &&
      phone &&
      phone.length > 8 &&
      addressData?.zonecode &&
      (shipping || (!shipping && scheduleData)) &&
      card !== undefined &&
      allChecked
    ) {
      setIsActiveBtn.on();
    }
  };

  useEffect(() => {
    checkActiveBtn();
  }, [
    name,
    phone,
    addressData,
    deliveryMethod,
    shipping,
    scheduleData,
    card,
    allChecked,
  ]);

  /* 가맹점 식별코드 */
  // const userCode: string = "imp10391932";
  const userCode: string = "imp32970589";
  const pg: string = getPGType();

  const { mutate: orderMerchantUidMutate } = useMutation(
    callOrderMerchantUidApi,
    {
      onSuccess: (data, variables, context) => {
        console.log("orderMerchantUidMutate : ", variables, data);

        if (data.status === ResStatus.RES_SUCCESS) {
          onPayment(data.command.merchant_uid);
        } else if (data.status === ResStatus.RES_UNAUTHORIZED) {
          pathNavigate("/*", {
            state: { session: "true" },
            replace: true,
          });
        } else {
          toast({
            title: "오류",
            description: data.result_message,
            status: "error",
            duration: 3000,
            isClosable: true,
            position: "top",
          });
        }
      },
      onError: (error: any) => {
        toast({
          title: "오류",
          description: error,
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top",
        });
      },
    }
  );

  function onClickPayment(e: any) {
    e.preventDefault();

    const channel = localStorage.getItem("channel");
    orderMerchantUidMutate({
      item_id: orderData.map((order) => order.item_id),
      amount: totalPrice,
      delivery_method: !shipping
        ? 0
        : channel === "smcare" || channel === "cosmocare"
        ? 1
        : 3,
      untact_yn: scheduleData?.isFace ? 0 : 1,
      reservation_date: shipping ? 0 : Number.parseInt(scheduleData?.date!),
      address_name: name,
      address_phone: phone,
      address: addressData.roadAddress,
      address_detail: addressData.detailAddress,
      post_num: addressData.zonecode,
      sido: addressData.sido,
      sigungu: addressData.sigungu,
      sigungu_code: addressData.sigunguCode,
      comment: comments,
      comment_save: 0,
    });
  }

  const onPayment = (merchantUid: string) => {
    /* 결제 데이터 */
    const data = {
      pg: pg,
      pay_method: card ? "card" : "trans",
      // currency: undefined,
      // notice_url: undefined,
      // display: undefined,
      // app_scheme: "minthouse_web",
      // tax_free: undefined,

      merchant_uid: merchantUid,
      name: "민트하우스",
      amount: totalPrice,
      buyer_name: name,
      buyer_tel: phone,
      buyer_email: "",
      buyer_addr: `${addressData.roadAddress} ${addressData.detailAddress}`,
      buyer_postcode: addressData.zonecode,

      custom_data: orderData.map((v) => v.item_id),

      vbank_due: undefined,
      digital: undefined,
      language: undefined,
      biz_num: undefined,
      customer_uid: undefined,
      naverPopupMode: undefined,
      naverUseCfm: undefined,
      naverProducts: undefined,
      niceMobileV2: true,
      escrow: false,
      m_redirect_url: `${window.location.origin}/secure/payment`,
    };

    const { IMP } = window;
    IMP.init(userCode);
    IMP.request_pay(data, function (response: any) {
      //결제 후 호출되는 callback함수
      if (response.success) {
        console.log(response);
        //결제 성공
        // apply_num: "30033903";
        // bank_name: null
        // buyer_addr: "서울 강남구 봉은사로 지하 102 102"
        // buyer_email: "oozcoo@naver.com"
        // buyer_name: "이동준"
        // buyer_postcode: "06120"
        // buyer_tel: "010-9119-1901"
        // card_name: "국민KB카드"
        // card_number: "557042*********9"
        // card_quota: 0
        // currency: "KRW"
        // custom_data:[670]
        // imp_uid: "imp_838013501799"
        // merchant_uid: "202305229AY0EDU1FDC7AD"
        // name: "민트하우스"
        // paid_amount: 279
        // paid_at: 1684731037
        // pay_method: "card"
        // pg_provider: "html5_inicis"
        // pg_tid: "StdpayCARDINIpayTest20230522135037212396"
        // pg_type: "payment"
        // receipt_url: "https://iniweb.inicis.com/DefaultWebApp/mall/cr/cm/mCmReceipt_head.jsp?noTid=StdpayCARDINIpayTest20230522135037212396&noMethod=1"
        // status: "paid"
        // success: true
        const { success, merchant_uid, imp_uid, error_code, error_msg } =
          response;
        pathNavigate(
          `/secure/payment?imp_success=${success}&merchant_uid=${merchant_uid}&imp_uid=${imp_uid}&error_code=${error_code}&error_msg=${error_msg}`
        );
      } else {
        toast({
          title: response.error_code,
          description: response.error_msg,
          status: "error",
          duration: 3000,
          isClosable: true,
          position: "top",
        });
      }
    });
  };

  useEffect(() => {
    const items = query.items
      ? query.items
          ?.toString()
          .split(",")
          .map((v) => Number.parseInt(v))
      : [];
    console.log("items : ", items);
    if (items && items.length > 0) {
      itemListMutate({
        item_id: items,
        item_status: BasketListStatus.BLS_DEFAULT,
      });
    }
  }, []);

  return (
    <>
      <Box>
        <Center my={"18px"} fontSize="1.25rem" fontWeight={"semibold"}>
          주문 및 결제
        </Center>

        <Box>
          <Box mx="20px">
            <ShippingInput
              title="픽업/배송 정보"
              name={name}
              phone={phone}
              addressData={addressData}
              callBackName={onChangeName}
              callBackPhone={onChangePhone}
              callBackSearchPostCode={setActivePost.toggle}
              callBackDetailAddress={onChangeDetailAddress}
            />
            <HStack
              fontSize={"0.75rem"}
              fontWeight="semibold"
              color={true ? "#bdbdbd" : "#128cfe"}
              mb="1rem"
            >
              {/* <Text>!</Text>
                        <Text>
                            {!parcel
                                ? "주소를 입력하면 픽업/배송 방식을 선택할 수 있어요."
                                : isArea
                                ? "버틀러 방문과 택배 모두 주문 가능한 주소입니다."
                                : "택배 주문만 가능한 주소입니다"}
                        </Text> */}
            </HStack>
          </Box>
          <Box bgColor={"#f5f6f8"} h={"0.5rem"} />

          <Box mx="20px" mt="1rem" mb="1rem">
            {/* <SubTitle>픽업/배송 방식</SubTitle>
                    <HStack mb="0.5rem">
                        <SelectBtn
                            borderWidth={parcel && shipping ? "2px" : "1px"}
                            borderColor={
                                parcel
                                    ? shipping
                                        ? "mint.500"
                                        : "#cfcfcf"
                                    : "#eee"
                            }
                            bgColor={parcel && shipping ? "#f9fefb" : "white"}
                            color={parcel ? "black" : "#eeeeee"}
                            callbackOnClick={() => changeShipping(true)}
                            label={"택배"}
                        />
                        <SelectBtn
                            borderWidth={butler && !shipping ? "2px" : "1px"}
                            borderColor={
                                butler
                                    ? !shipping
                                        ? "mint.500"
                                        : "#cfcfcf"
                                    : "#eee"
                            }
                            bgColor={butler && !shipping ? "#f9fefb" : "white"}
                            color={butler ? "black" : "#eeeeee"}
                            callbackOnClick={() => changeShipping(false)}
                            label={"버틀러"}
                        />
                    </HStack> */}
            {/* <Text
                        mt="0.5rem"
                        fontSize={"0.75rem"}
                        fontWeight="semibold"
                        color={"#128cfe"}
                        mb="1rem"
                    >
                        {addressData.zonecode
                            ? shipping
                                ? "영업일 기준 1-2일 이내 택배원이 방문드립니다."
                                : "버틀러가 고객님의 주소로 예약일시에 방문드립니다."
                            : "'주소검색'으로 주소를 먼저 입력해 주세요"}
                    </Text> */}

            <Box w="100%" mt={"20px"}>
              <Text fontSize={"0.813rem"} fontWeight="semibold" mb="0.5rem">
                요청사항
              </Text>
              <Textarea
                h="7.5rem"
                fontSize={"0.938rem"}
                fontWeight="medium"
                focusBorderColor={"gray.100"}
                borderRadius="sm"
                _placeholder={{ color: "#bdbdbd" }}
                placeholder="공동입구 번호, 픽업과 배송 요청사항을 입력해 주세요. (선택)"
                mb="1.5rem"
                value={comments}
                onChange={onChangeComments}
              />
            </Box>

            <Box
              border={"1px"}
              borderColor="#eeeeee"
              px="1rem"
              py="1.125rem"
              mb="1.125rem"
              bgColor={"#fafafa"}
            >
              <Text
                fontSize={"0.813rem"}
                fontWeight="semibold"
                color={"#757575"}
                mb="0.5rem"
              >
                ⓘ 다른 주소로 배송 받고 싶어요.
              </Text>
              <Text
                fontSize={"0.75rem"}
                fontWeight="semibold"
                color={"#707070"}
                whiteSpace="pre"
              >
                {
                  "서비스가 완료된 제품을 다른 주소로 받고 싶으실 경우,\n민트하우스에 상담 요청해 주세요"
                }
              </Text>
            </Box>
            {/* {addressData.zonecode &&
                        (shipping ? (
                            <Box
                                border={"1px"}
                                borderColor="#eeeeee"
                                px="1rem"
                                py="1.125rem"
                                mb="1.125rem"
                                bgColor={"#fafafa"}
                            >
                                <Text
                                    fontSize={"0.813rem"}
                                    fontWeight="semibold"
                                    color={"#757575"}
                                    mb="0.5rem"
                                >
                                    ⓘ 다른 주소로 배송 받고 싶어요.
                                </Text>
                                <Text
                                    fontSize={"0.75rem"}
                                    fontWeight="semibold"
                                    color={"#707070"}
                                    whiteSpace="pre"
                                >
                                    {
                                        "서비스가 완료된 제품을 다른 주소로 받고 싶으실 경우,\n민트하우스에 상담 요청해 주세요"
                                    }
                                </Text>
                            </Box>
                        ) : (
                            <Box>
                                <Text
                                    fontSize={"0.813rem"}
                                    fontWeight="semibold"
                                    mb="0.5rem"
                                >
                                    예약일시 *
                                </Text>

                                <ReservationInfo
                                    reservationDate={scheduleData?.date!}
                                    isFace={scheduleData?.isFace!}
                                    comments={comments}
                                    callbackReservation={
                                        setActiveSchedule.toggle
                                    }
                                    callbackOnChangeComments={onChangeComments}
                                />
                            </Box>
                        ))} */}
          </Box>
          <Box bgColor={"#f5f6f8"} h={"0.5rem"} />

          <Box mx="20px" mt="1rem">
            <SubTitle>주문내역</SubTitle>
            {orderData.map((data) => (
              <OrderItem key={`order_item_${data.item_id}`} data={data} />
            ))}
          </Box>
          <Box bgColor={"#f5f6f8"} h={"0.5rem"} />

          <Box mx="20px" mt="1rem">
            <SubTitle>결제수단</SubTitle>
            <HStack mb="1.25rem">
              <SelectBtn
                borderWidth={card != null && card ? "2px" : "1px"}
                borderColor={card != null && card ? "mint.500" : "#cfcfcf"}
                bgColor={card != null && card ? "#f9fefb" : "white"}
                color={"black"}
                callbackOnClick={() => changePaymentMethod(true)}
                label={"신용카드・간편결제"}
              />
              <SelectBtn
                borderWidth={card != null && !card ? "2px" : "1px"}
                borderColor={card != null && !card ? "mint.500" : "#cfcfcf"}
                bgColor={card != null && !card ? "#f9fefb" : "white"}
                color={"black"}
                callbackOnClick={() => changePaymentMethod(false)}
                label={"계좌이체"}
              />
            </HStack>
          </Box>
          <Box bgColor={"#f5f6f8"} h={"0.5rem"} />

          <Box mx="20px" mt="1rem">
            <SubTitle mb={"0.5rem"}>결제정보</SubTitle>
            <HStack justify="space-between" mb="0.313rem">
              <Box fontSize={"0.875rem"} fontWeight="medium" color={"#757575"}>
                서비스 금액
              </Box>
              <Box fontSize={"0.875rem"} fontWeight="medium" color="#212121">
                {`${digit(servicePrice)} 원`}
              </Box>
            </HStack>
            <HStack justify="space-between" mb="0.313rem">
              <HStack>
                <Box
                  fontSize={"0.875rem"}
                  fontWeight="medium"
                  color={"#757575"}
                >
                  <Text>배송비</Text>
                </Box>
              </HStack>
              <Box fontSize={"0.875rem"} fontWeight="medium" color="#212121">
                {digit(deliveryPrice)} 원
              </Box>
            </HStack>
            <HStack justify="space-between" mb="0.625rem">
              <Box fontSize={"0.875rem"} fontWeight="medium" color={"#757575"}>
                할인 금액
              </Box>
              <Box fontSize={"0.875rem"} fontWeight="medium" color="#212121">
                {digit(discount)} 원
              </Box>
            </HStack>
            <Divider mb="0.625rem" />
            <HStack mb={"1rem"} justify="space-between">
              <Text fontSize={"1rem"} fontWeight="semibold">
                총 결제 금액
              </Text>
              <Text fontSize={"1rem"} fontWeight="semibold">
                {`${digit(totalPrice)} 원`}
              </Text>
            </HStack>
            <HStack
              fontSize={"0.75rem"}
              fontWeight="semibold"
              color={"#bdbdbd"}
              mb="1rem"
            >
              <Text>!</Text>
              <Text>
                배송비는 제품의 재포장 및 고객에게 재발송해드리는 비용입니다.
              </Text>
            </HStack>
          </Box>
          <Box bgColor={"#f5f6f8"} h={"0.5rem"} />

          <Box mx="20px" paddingBottom={10}>
            <SubTitle mt="1rem">주문 약관 동의</SubTitle>
            <Checkbox
              mb="0.75rem"
              colorScheme={"black_button"}
              isChecked={allChecked}
              onChange={(e) =>
                setCheckedItems([
                  e.target.checked,
                  e.target.checked,
                  e.target.checked,
                ])
              }
            >
              <Text fontSize={"0.875rem"} fontWeight="semibold">
                전체 동의합니다.
              </Text>
            </Checkbox>

            <Divider mb="0.75rem" />
            <HStack justifyContent={"space-between"} mb="0.75rem">
              <Flex>
                <Checkbox
                  colorScheme={"black_button"}
                  isChecked={checkedItems[0]}
                  onChange={(e) =>
                    setCheckedItems([
                      e.target.checked,
                      checkedItems[1],
                      checkedItems[2],
                    ])
                  }
                >
                  <Text fontSize={"0.875rem"} fontWeight="medium">
                    이용약관에 동의 합니다.
                  </Text>
                </Checkbox>
                <Text
                  fontSize={"0.875rem"}
                  fontWeight="medium"
                  color={"#9e9e9e"}
                >
                  (필수)
                </Text>
              </Flex>
              <Box
                border={0}
                bgColor={"white"}
                fontSize={"0.75rem"}
                fontWeight="medium"
                onClick={() => {
                  // window.open(
                  //     "https://mintapps.oopy.io/terms",
                  //     "_blank"
                  // );
                  setUrl("https://mintapps.oopy.io/terms");
                  setIsOpen(true);
                }}
              >
                보기
              </Box>
            </HStack>
            <HStack justifyContent={"space-between"} mb="0.75rem">
              <Flex>
                <Checkbox
                  colorScheme={"black_button"}
                  isChecked={checkedItems[1]}
                  onChange={(e) => {
                    e.preventDefault();
                    setCheckedItems([
                      checkedItems[0],
                      e.target.checked,
                      checkedItems[2],
                    ]);
                  }}
                >
                  <Text fontSize={"0.875rem"} fontWeight="medium">
                    개인정보 수집 및 이용에 동의 합니다.
                  </Text>
                </Checkbox>
                <Text
                  fontSize={"0.875rem"}
                  fontWeight="medium"
                  color={"#9e9e9e"}
                >
                  (필수)
                </Text>
              </Flex>
              <Box
                border={0}
                bgColor={"white"}
                fontSize={"0.75rem"}
                fontWeight="medium"
                onClick={() => {
                  // window.open(
                  //     "https://mintapps.oopy.io/terms",
                  //     "_blank"
                  // );
                  setUrl("https://mintapps.oopy.io/privacy");
                  setIsOpen(true);
                }}
              >
                보기
              </Box>
            </HStack>
            <HStack justifyContent={"space-between"} mb="0.75rem">
              <Flex>
                <Checkbox
                  colorScheme={"black_button"}
                  isChecked={checkedItems[2]}
                  onChange={(e) => {
                    setCheckedItems([
                      checkedItems[0],
                      checkedItems[1],
                      e.target.checked,
                    ]);
                  }}
                >
                  <Text fontSize={"0.875rem"} fontWeight="medium">
                    만 14세 이상입니다.
                  </Text>
                </Checkbox>
                <Text
                  fontSize={"0.875rem"}
                  fontWeight="medium"
                  color={"#9e9e9e"}
                >
                  (필수)
                </Text>
              </Flex>
            </HStack>
          </Box>
          <CompanyInfo />
        </Box>
        <Box h="86px" />

        <Container
          position={"fixed"}
          bottom={0}
          bgColor="#fff"
          maxW={"768px"}
          minW={"320px"}
          w="100%"
          h="86px"
          px={"20px"}
          py="15px"
          borderTop={"1px"}
          borderTopColor={"#e0e0e0"}
        >
          <Input
            w="100%"
            h={"100%"}
            fontSize={"1rem"}
            fontWeight="semibold"
            bg={isActiveBtn ? "#5bbca6" : "#e0e0e0"}
            color={"#fff"}
            type="submit"
            onClick={onClickPayment}
            value={`${digit(totalPrice)}원 결제하기`}
            disabled={!isActiveBtn}
          />
        </Container>

        <DaumPostCodeModal isOpen={activePost} callback={callbackPostCode} />
        <ScheduleRecordModal
          reservationType="pickup"
          data={scheduleData}
          isOpen={activeSchedule}
          callback={callbackSchedule}
        />
      </Box>
      <ExternalLinkModal isOpen={isOpen} url={url} onClose={onClose} />
    </>
  );
};

export default withAuth(OrderSheet);
